module.exports = __webpack_public_path__ + "static/media/health-check.f588ea55.svg";